import React, { useEffect, useState } from 'react';
import { showResponseSnackBar } from 'consts';
import { useSelector } from 'react-redux';
import Button from 'tradevan-ui/Button';
import { isUndefined } from 'tradevan-ui/consts';
import useAxios from 'axios/useAxios';
import { MethodEnum } from 'axios/type';
import { getUserInfoReducer } from 'reducer/common/userInfo';
import StatusEnum from 'axios/enum';
import { formatDate } from 'components/DatePicker/consts';
import { useForm } from 'react-hook-form';
import TableTit from 'components/_form/TableTit';
import Rim from 'components/_form/Rim';
import DivSX from 'tradevan-ui/@emotion/DivSX';
import ButtonVariantEnum from 'tradevan-ui/Button/enum';
import LogRecordModal from 'view/Layout/Project/components/LogRecordModal';
import { FIRST_PAGE, initPage } from 'components/Table/consts';
import {
  EnumFunctionId,
  EnumMasterSort,
  EnumRetailerSetup,
} from 'view/Layout/enum';
import { initMasterSort } from 'view/Layout/consts';
import { IqueryDateList } from 'view/Layout/type';
import {
  EnumMaster,
  IretailerSetupRcv,
  useInitMaster,
  useInitRetailerSetup,
  RcvQueryState,
  RcvQueryForm,
  RcvQueryFormDetail,
  Imaster,
  EnumDetail,
} from './init';
import QuerySecion from './components/QuerySecion';
import {
  Iconditions,
  IqueryReceiveRequest,
  IqueryReceiveResponse,
} from './type';
import ResultSecion from './components/ResultSecion';
import DownloadBtn from '../components/DownloadBtn';
import useQueryDate from './components/QuerySecion/useQueryDate';
import { nameMaster } from './consts';
/** 驗收單 首頁 */
const RcvQuery = () => {
  const initRetailerSetup = useInitRetailerSetup();
  const axios = useAxios();
  /** 表單顯示欄位設定 */
  const [retailerSetup, setRetailerSetup] = useState(initRetailerSetup);
  /** 體系別 OpTrs /登入者資料 */
  const userInfoReducer = useSelector(getUserInfoReducer);
  const initState: RcvQueryState = {
    master: useInitMaster(),
    masterSort: initMasterSort,
    detail: [],
    pageObj: initPage,
    showResult: false,
    retailerTypeOption: [],

    showLogRecordModal: false,
    logRecordData: [],
    queryDateList: [],
  };

  // #region useForm系列
  const initQueryOrderForm: RcvQueryForm = {
    master: initState.master,
    masterSort: initState.masterSort,
  };
  const formReturn = useForm<RcvQueryForm>({
    defaultValues: initQueryOrderForm,
  });
  const formReturnDetail = useForm<RcvQueryFormDetail>({
    defaultValues: {
      master: initState.master,
      detail: initState.detail,
      pageObj: initState.pageObj,
      masterSort: initState.masterSort,
    },
  });

  const { watch, setValue, handleSubmit, reset } = formReturn;
  const { setValue: setValueDetail, watch: watchDetail } = formReturnDetail;

  const master = watch('master');
  const masterSort = watch('masterSort');
  const pageObj = watchDetail('pageObj');
  const detail = watchDetail('detail');

  // #endregion useForm系列

  /** 查覽結果 */
  const [showResult, setShowResult] = useState(initState.showResult);
  /** 操作歷程 dialog */
  const [showLogRecordModal, setShowLogRecordModal] = useState(
    initState.showLogRecordModal,
  );
  /** 操作歷程 資料 */
  const [logRecordData, setLogRecordData] = useState(initState.logRecordData);
  /** 體系別選項 */
  const [retailerTypeOption, setRetailerTypeOption] = useState(
    initState.retailerTypeOption,
  );
  /** 日期下拉選單 */
  const [queryDateList, setQueryDateList] = useState<IqueryDateList[]>([]);
  const { queryDateOpTrs, handleQueryDateOptionChange } = useQueryDate(
    queryDateList,
    formReturn,
  );

  const getRequest = (obj: Imaster): Iconditions => {
    const {
      // retailerId,
      supplierCode,
      storeNo,
      receiveDate,
      orderNo,
      receiveNo,
      supplierCodeLike,
      queryDateSelect,
    } = retailerSetup[EnumRetailerSetup.queryConditions];

    return {
      retailerId: obj[EnumMaster.retailerId],
      ...(supplierCode && { supplierCode: obj[EnumMaster.supplierCode] }),
      ...(supplierCodeLike && {
        supplierCodeLike: obj[EnumMaster.supplierCodeLike],
      }),
      ...(storeNo && { storeNo: obj[EnumMaster.storeNo] }),
      ...(receiveDate && {
        receiveStartDate: formatDate()(obj[EnumMaster.receiveStartDate]),
        receiveEndDate: formatDate()(obj[EnumMaster.receiveEndDate]),
      }),
      ...(orderNo && {
        orderStartNo: obj[EnumMaster.orderStartNo],
        orderEndNo: obj[EnumMaster.orderEndNo],
      }),
      ...(queryDateSelect && {
        queryDateSelect: obj[EnumMaster.queryDateValue],
      }),
      ...(queryDateSelect && {
        queryDateBegin: formatDate()(obj[EnumMaster.queryDateBegin]),
        ...(queryDateSelect && {
          queryDateEnd: formatDate()(obj[EnumMaster.queryDateEnd]),
        }),
      }),
      ...(receiveNo && {
        receiveStartNo: obj[EnumMaster.receiveStartNo],
        receiveEndNo: obj[EnumMaster.receiveEndNo],
      }),
    };
  };

  /** 表單查詢 */
  const handleSearch =
    (
      page = FIRST_PAGE,
      pageSize = pageObj.pageSize,
      keepSelected = true,
      doLoading = true,
    ) =>
    async (input: RcvQueryFormDetail | RcvQueryForm) => {
      const requestPage = {
        pageNo: !isUndefined(page) ? page : pageObj.pageNo,
        pageSize: !isUndefined(pageSize) ? pageSize : pageObj.pageSize,
      };
      console.log('basstest', input.master);
      const response = await axios.doAxios<
        IqueryReceiveRequest,
        IqueryReceiveResponse
      >(
        MethodEnum.post,
        'receive/queryReceive',
        {
          // 驗收單多一層 queryCriteria
          queryCriteria: {
            conditions: getRequest(input.master),
            querySorts: masterSort
              .filter((v) => v[EnumMasterSort.property] !== '')
              .map((v) => ({
                ...v,
                [EnumMasterSort.desc]: v.desc ? 'Y' : 'N',
              })),
            ...requestPage,
          },
        },
        doLoading,
      );

      setShowResult(true);
      if (
        response &&
        response.data.data &&
        response.data.status === StatusEnum.完成
      ) {
        const { data } = response.data;
        setValueDetail('master', input.master);
        setValueDetail('pageObj', data.page);
        setValueDetail(
          'detail',
          data.contents.map((v, i) => ({
            ...v,
            selected:
              // 刷新資料後 保留selected的值
              keepSelected &&
              v[EnumDetail.orderNoCnt] === detail?.[i]?.[EnumDetail.orderNoCnt]
                ? detail?.[i]?.selected
                : false,
          })),
        );
        setValueDetail('masterSort', masterSort); // 20230718 sukie. su 排序也需要傳到後面處理
      } else {
        setValueDetail('detail', []);
      }
      showResponseSnackBar(response?.data);
    };

  /** 重置表單 */
  const handleReset = () => {
    // 1. 更新defaultValue
    reset(initQueryOrderForm);
    // 2. 重置後取消所有勾選
    setValueDetail(
      'detail',
      detail.map((v) => ({
        ...v,
        selected: false,
      })),
    );
    // 動態日期預設帶入第一筆，並重新設定開始日期、結束日期
    if (queryDateList != null && queryDateList.length > 0) {
      setValue(nameMaster(EnumMaster.queryDateValue), queryDateOpTrs[0].value);
      handleQueryDateOptionChange(queryDateOpTrs[0].value);
    }
  };

  /** 取得通路別的欄位顯示設定檔案 */
  const handleUpdateRetailerSetup = async (retailerId: string) => {
    const response = await axios.doAxios<
      unknown,
      { retailerSetup: IretailerSetupRcv }
    >(MethodEnum.post, 'retailerSetup/queryWebRetailerSetup', {
      retailerId,
      functionId: EnumFunctionId.驗收單,
      role: userInfoReducer.role,
    });

    if (response) {
      const { data, status } = response.data;
      if (status === StatusEnum.完成) {
        setRetailerSetup({
          [EnumRetailerSetup.queryConditions]: {
            ...initRetailerSetup[EnumRetailerSetup.queryConditions],
            ...data.retailerSetup[EnumRetailerSetup.queryConditions],
          },
          [EnumRetailerSetup.queryResults]: {
            ...initRetailerSetup[EnumRetailerSetup.queryResults],
            ...data.retailerSetup[EnumRetailerSetup.queryResults],
          },
          [EnumRetailerSetup.exportItemList]: {
            ...initRetailerSetup[EnumRetailerSetup.exportItemList],
            ...data.retailerSetup[EnumRetailerSetup.exportItemList],
          },
          [EnumRetailerSetup.queryDateList]: {
            ...initRetailerSetup[EnumRetailerSetup.queryDateList],
            ...data.retailerSetup[EnumRetailerSetup.queryDateList],
          },
        });
        // 不管有沒有值都需要設定，由查詢頁判斷是否顯示物件
        setQueryDateList(data.retailerSetup[EnumRetailerSetup.queryDateList]);
      }
    }
  };

  useEffect(() => {
    const retailerId = initState.master[EnumMaster.retailerId];
    if (retailerId !== '') {
      // 欄位權限取得
      handleUpdateRetailerSetup(retailerId);
    }

    // 由於 initState.master.retailerId 會根據不同的來源有異動，故有變動要重新更新 master
    setValue('master', initState.master);

    // 取得 userInfo 時，或得體系別下拉選單
    setRetailerTypeOption(
      (userInfoReducer?.retailerIds || []).map((v) => ({
        value: v.retailerId,
        label: v.retailerName,
      })),
    );
  }, [userInfoReducer]);

  return (
    <>
      <LogRecordModal
        data={logRecordData}
        _show={[showLogRecordModal, setShowLogRecordModal]}
      />

      <TableTit>
        <span>驗收單下載</span>
        <DownloadBtn
          type="rcv"
          retailerSetup={retailerSetup}
          retailerId={master[EnumMaster.retailerId]}
          retailerIds={userInfoReducer.retailerIds}
        />
      </TableTit>
      <Rim>
        <form
          onSubmit={handleSubmit(
            handleSearch(pageObj.pageNo, pageObj.pageSize, false),
          )}
        >
          <QuerySecion
            _showResult={[showResult, setShowResult]}
            handleReset={handleReset}
            handleUpdateRetailerSetup={handleUpdateRetailerSetup}
            retailerTypeOption={retailerTypeOption}
            formReturn={formReturn}
            _retailerSetup={[retailerSetup, setRetailerSetup]}
            queryDateOption={queryDateOpTrs}
            handleQueryDateOptionChange={handleQueryDateOptionChange}
          />
          <DivSX className="btn-box">
            <Button
              rounded
              variant={ButtonVariantEnum['outline-primary']}
              startIcon={<i className="icon-redo" />}
              onClick={() => handleReset()}
            >
              重置
            </Button>
            <Button
              type="submit"
              rounded
              startIcon={<i className="icon-common_search-24px" />}
            >
              查詢
            </Button>
          </DivSX>
        </form>
        {showResult && (
          <ResultSecion
            formReturnDetail={formReturnDetail}
            handleSearch={handleSearch}
            _logRecordData={[logRecordData, setLogRecordData]}
            _retailerSetup={[retailerSetup, setRetailerSetup]}
            _showLogRecordModal={[showLogRecordModal, setShowLogRecordModal]}
            userInfoReducer={userInfoReducer}
          />
        )}
      </Rim>
    </>
  );
};
export default RcvQuery;
